import Hero from "./Hero";
import Gallery from "./Gallery";

const HomeV3 = () => {
  return (
    <>
      <Hero />
      <Gallery />
    </>
  );
};

export default HomeV3;
